import { Fuel } from "@niral"
import CentralLock from "~/components/assests/svg/centralLock"
import CityLoading from "~/components/assests/svg/cityLoadingSvg"
import CityUnloading from "~/components/assests/svg/cityUnloadingSvg"
import DigitalLock from "~/components/assests/svg/digitalLockSvg"
import ForkLiftLoading from "~/components/assests/svg/forkliftIconSvg"
import GPSRequired from "~/components/assests/svg/gpsRequiredSvg"
import HeightWidth from "~/components/assests/svg/heightWidthsvg"
import Hooks from "~/components/assests/svg/hooksSvg"
import NoBeeding from "~/components/assests/svg/noBeedingSvg"
import SmoothFlooring from "~/components/assests/svg/smoothFlooringSvg"
import SteelPlatform from "~/components/assests/svg/steelPlatformSvg"
import Tarpoline from "~/components/assests/svg/tarpolineSvg"
import type { Requirement } from "~/core/Indent/indentSchema"
import {  Schema as S } from "effect"

export const TruckTypeListSchema = S.Struct({
  id: S.Number,
  name: S.String,
  code: S.String,
  truck_type_group_id: S.Number,
  shortname: S.String,
});

export type TruckTypeList = S.Schema.Type<typeof TruckTypeListSchema>;

export const truck = {
    truckTypeGroupNames: {
      2: "Closed",
      1: "Open",
      3: "Trailer"
    } as Record<number, string>,
    truck_requirements: (requirements: Requirement | undefined, truck_group_id: number | null)=> {
        return [
            {
              id: 1,
              name: "Forklift loading",
              group_id: 2,
              icon: ForkLiftLoading,
              selected_style: 'stroke-secondary fill-none'
            },
            {
              id: 3,
              name: "Hooks",
              group_id: 2,
              icon: Hooks,
              selected_style: 'stroke-none fill-secondary'
            },
            {
              id: 9,
              name: "GPS required",
              group_id: 2,
              icon: GPSRequired,
              selected_style: 'stroke-secondary fill-none'
            },
            {
              id: 11,
              name: "Forklift loading",
              group_id: 1,
              icon: ForkLiftLoading,
              selected_style: 'stroke-secondary fill-none'
            },
            {
              id: 14,
              name: "GPS required",
              group_id: 1,
              icon: GPSRequired,
              selected_style: 'stroke-secondary fill-none'
            },
            {
              id: 2,
              name: "Steel platform",
              group_id: 2,
              icon: SteelPlatform,
              selected_style: 'stroke-none fill-secondary'
            },
            {
              id: 4,
              name: "No beading",
              group_id: 2,
              icon: NoBeeding,
              selected_style: 'stroke-secondary fill-none'
            },
            {
              id: 5,
              name: "Smooth flooring",
              group_id: 2,
              icon: SmoothFlooring,
              selected_style: 'stroke-none fill-secondary'
            },
            {
              id: 6,
              name: "Central lock",
              group_id: 2,
              icon: CentralLock,
              selected_style: 'stroke-secondary fill-none'
            },
            {
              id: 7,
              name: "Digital lock",
              group_id: 2,
              icon: DigitalLock,
              selected_style: 'stroke-secondary fill-none'
            },
            {
              id: 10,
              name: "Non - CNG",
              group_id: 2,
              isIcon: true,
              icon: Fuel,
            },
            {
              id: 12,
              name: "Steel platform",
              group_id: 1,
              icon: SteelPlatform,
              selected_style: 'stroke-none fill-secondary'
            },
            {
              id: 15,
              name: "Non - CNG",
              group_id: 1,
              isIcon: true,
              icon: Fuel,
            },
            {
              id: 16,
              name: "City loading",
              group_id: 1,
              icon: CityLoading,
              selected_style: 'fill-secondary'
            },
            {
              id: 19,
              name: "City unloading",
              group_id: 2,
              icon: CityUnloading,
              selected_style: 'fill-secondary'
            },
            {
              id: 17,
              name: "City unloading",
              group_id: 1,
              icon: CityUnloading,
              selected_style: 'fill-secondary'
            },
            {
              id: 18,
              name: "City loading",
              group_id: 2,
              icon: CityLoading,
              selected_style: 'fill-secondary'
            },
            {
              id: 20,
              name: `Tarpaulin ${requirements?.tarpoline_count} Nos`,
              group_id: truck_group_id,
              show: !!requirements?.tarpoline_count  && requirements?.tarpoline_count  > 0,
              icon: Tarpoline,
              selected_style: 'stroke-secondary fill-none'
            },
            // {
            //   id: 22,
            //   name: `Notes: ${requirements?.notes}`,
            //   group_id: truck_group_id,
            //   isIcon: true,
            //   show: !!requirements?.notes,
            //   icon: NotebookPen,
            // },
            {
              id: 21,
              name: `${requirements?.truck_breadth}ft X ${requirements?.truck_height}ft`,
              group_id: truck_group_id,
              show: !!(requirements?.truck_breadth && requirements?.truck_height),
              icon: HeightWidth,
              selected_style: 'stroke-secondary fill-none'
            },
          ]
    },
    TRUCK_TRACKED_BY: [
      { id: 1, name: "Employee" },
      { id: 2, name: "Partner" },
      { id: 3, name: "Customer" },
      { id: 10, name: "Fastag" },
      { id: 99, name: "Audio" },
      { id: 12, name: "Unloading" },
    ],
    SUBSCRIPTION_ORIGIN_TYPE :{
      MANUAL: 1,
      AUTO_RENEWAL: 2,
      HIGHER_ORDER: 3,
      COUPON: 4,
      BRANDING: 5
    },
    SUBSCRIPTION_PLAN_TYPE: {
      MONTHLY: 1,
      YEARLY: 2,
      QUARTERLY: 3
    },
    SUBSCRIPTION_REVERSAL_ALLOWED: [1,2,3],
    TRUCK_STATUS_NAME :{
      DEACTIVATED: 6
    },
    SEARCH_TRUCK_STATUS: {
      CONFIRMED: "Confirmed",
      LOADING: "Loading",
      INTRANSIT: "Intransit",
      UNLOADING: "Unloading",
      WAITING_FOR_LOAD: "Waiting for Load",
      DEACTIVATED: "Deactivated",
      ASSIGNED: "Assigned",
      INTRANSIT_HALTING: "Intransit halting",
      VERIFICATION: "Verification",
      BREAKDOWN: "Breakdown",
      BLACKLISTED: "Blacklisted",
      ALLOCATED:'Allocated'
    },
    TRUCK_TYPE_LIST: [
      {
        id: 36,
        name: "32 Feet Triple Axle",
        shortname: "32 Ft TXL",
        code: "TXL",
        truck_type_group_id: 2
      },
      {
        id: 38,
        name: "22 Feet Open",
        shortname: "22 Ft Open",
        code: "22F Open",
        truck_type_group_id: 1
      },
      {
        id: 22,
        name: "24 Feet Open",
        shortname: "24 Ft Open",
        code: "24F Open",
        truck_type_group_id: 1
      },
      {
        id: 35,
        name: "20 Feet Open",
        shortname: "20 Ft Open",
        code: "20F Open",
        truck_type_group_id: 1
      },
      {
        id: 37,
        name: "17 Feet Open",
        shortname: "17 Ft Open",
        code: "17F Open",
        truck_type_group_id: 1
      },
      {
        id: 7,
        name: "10 Whl Open",
        shortname: "10 W",
        code: "10W",
        truck_type_group_id: 1
      },
      {
        id: 18,
        name: "12 Whl Open",
        shortname: "12 W",
        code: "12W",
        truck_type_group_id: 1
      },
      {
        id: 33,
        name: "14 Whl Open",
        shortname: "14 W",
        code: "14W",
        truck_type_group_id: 1
      },
      {
        id: 24,
        name: "32 Feet Single Axle High Cube",
        shortname: "32 Ft SXL HQ",
        code: "SXLHQ",
        truck_type_group_id: 2
      },
      {
        id: 27,
        name: "32 Feet Single Axle",
        shortname: "32 Ft SXL",
        code: "SXL",
        truck_type_group_id: 2
      },
      {
        id: 20,
        name: "22 Feet Closed",
        shortname: "22 Ft",
        code: "22F",
        truck_type_group_id: 2
      },
      {
        id: 21,
        name: "24 Feet Closed",
        shortname: "24 Ft",
        code: "24F",
        truck_type_group_id: 2
      },
      {
        id: 16,
        name: "20 Feet Closed",
        shortname: "20 Ft",
        code: "20F",
        truck_type_group_id: 2
      },
      {
        id: 25,
        name: "32 Feet Multi Axle",
        shortname: "32 Ft MXL",
        code: "MXL",
        truck_type_group_id: 2
      },
      {
        id: 26,
        name: "32 Feet Multi Axle High Cube",
        shortname: "32 Ft MXL HQ",
        code: "MXLHQ",
        truck_type_group_id: 2
      },
      {
        id: 39,
        name: "16 Whl Open",
        shortname: "16 W",
        code: "16W",
        truck_type_group_id: 1
      },
      {
        id: 40,
        name: "18 Whl Open",
        shortname: "18 W",
        code: "18W",
        truck_type_group_id: 1
      },
      {
        id: 17,
        name: "20 Feet Flat Bed",
        shortname: "20 Ft Flat Bed",
        code: "20F Flat Bed",
        truck_type_group_id: 3
      },
      {
        id: 31,
        name: "40 Feet Flat Bed",
        shortname: "40 Ft Flat Bed",
        code: "40F Flat Bed",
        truck_type_group_id: 3
      },
      {
        id: 29,
        name: "40 Feet Semi Bed",
        shortname: "40 Ft Semi Bed",
        code: "40F Semi Bed",
        truck_type_group_id: 3
      },

      {
        id: 30,
        name: "40 Feet Low Bed",
        shortname: "40 Ft Low Bed",
        code: "40F Low Bed",
        truck_type_group_id: 3
      } 
    ],
    mxl_grouped_ids: [25, 26, 36],
    mxl_grouped_string: '36,25,26',
    mxl_group_id: 1,
    initialRoute: {
      p: 365,
      sAliasId: null,
      sourceId: 4,
      sourceBranchId: 6,
      sourceName: 'Chennai',
      dAliasId: null,
      destinationId: 253,
      destinationBranchId: 7,
      destinationName: 'Bangalore',
      transport_service: '32_feet_mxl_container',
    },
    tenTwelveFourteenWhlGroupIds: [5, 6, 7],
    truckGroup: {
      MXL: {
        id: 1,
        primary_group_name: '32FT MXL',
        web_name: '32 Feet Multi Axle Truck',
        ton: 15,
        percentValue: 1,
      },
      SXL: {
        id: 2,
        primary_group_name: '32FT SXL',
        web_name: '32 Feet Single Axle Truck',
        ton: 7,
        percentValue: 1,
      },
      '20FT': {
        id: 3,
        primary_group_name: '20/22/24FT',
        web_name: '20 Feet Container Truck',
        ton: 6,
        percentValue: 1,
      },
      '20FTO': {
        id: 4,
        primary_group_name: '17/19/20/22/24FT',
        web_name: '20 Feet Open Truck',
        ton: 6,
        percentValue: 1,
      },
      '10Whl': {
        id: 5,
        primary_group_name: '10 Whl',
        web_name: '10 Wheeler Open Truck',
        ton: 19,
        percentValue: 0.8,
      },
      '12Whl': {
        id: 6,
        primary_group_name: '12 Whl',
        web_name: '12 Wheeler Open Truck',
        ton: 25,
        percentValue: 0.75,
      },
      '14Whl': {
        id: 7,
        primary_group_name: '14 Whl',
        web_name: '14 Wheeler Open Truck',
        ton: 30,
        percentValue: 0.7,
      },
      '16Whl': {
        id: 8,
        primary_group_name: '16 Whl',
        web_name: '16 Wheeler Open Truck',
        ton: 35,
        percentValue: 0.7,
      },
      '18Whl': {
        id: 9,
        primary_group_name: '18 Whl',
        web_name: '18 Wheeler Open Truck',
        ton: 40,
        percentValue: 0.7,
      },
    },
    TRUCK_TONNAGE :{
      MIN: 5,
      MAX: 50
    }
}